import { Injectable } from '@angular/core'

import { PkwDatastore } from '../../pkw-data/pkw-datastore'
import { EmpresaQueVendeComCartoes } from '../../pkw-data/collect/empresa-que-vende-com-cartoes.model'

@Injectable()
export class EmpresaQueVendeComCartoesService {
    constructor(private pkwDatastore: PkwDatastore) {}

    obterTodas() {
        return this.pkwDatastore
            .findAll(EmpresaQueVendeComCartoes, {
                page: {
                    limit: 1000
                },
                include: 'empresa'
            })
            .map(response => response.getModels())
    }

    obterAtivas() {
        return this.pkwDatastore
            .findAll(EmpresaQueVendeComCartoes, {
                filter: {
                    empresa: {
                        ativa: true
                    }
                },
                page: {
                    limit: 1000
                },
                include: 'empresa'
            })
            .map(response => response.getModels())
    }

    obterPorIdExterno(idExterno: string) {
        return this.pkwDatastore
            .findAll(EmpresaQueVendeComCartoes, {
                filter: {
                    'empresa.idExterno': idExterno
                },
                include: 'empresa'
            })
            .map(response => response.getModels()[0])
    }
}



// WEBPACK FOOTER //
// ./src/app/core/services/empresa-que-vende-com-cartoes.service.ts